import { GET_PRODUCTS } from '../constants/product';
import { SHOW_LOADING, HIDE_LOADING } from '../constants/commons';

const initialState = {
    loading: false,
    products: [],
}

export const productReducer = (state = initialState, {type, payload}) => {
    switch (type) {
        case GET_PRODUCTS:
            return {...state, products: payload};
        case SHOW_LOADING:
            return {...state, loading: true};
        case HIDE_LOADING:
            return {...state, loading: false};
        default:
            return state;
    }
} 